import type { CarouselTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const carouselDark: CarouselTheme = {
  name: 'Carousel',
  common: commonDark,
  self
}

export default carouselDark
